module.exports = __webpack_public_path__ + "img/PRINT.607541f7.svg";